import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import { AuthShell } from "@/pages/AuthShell";
import { Loader2, CheckCircle2, XCircle } from "lucide-react";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    if (!token) { setStatus("error"); return; }
    api.post("/auth/verify-email", { token }).then(() => setStatus("ok")).catch(() => setStatus("error"));
  }, [token]);

  return (
    <AuthShell title="Verifikasi Email" footer={<Link to="/dashboard" className="text-teal font-semibold">Ke Dashboard</Link>}>
      <div data-testid="verify-result" className="text-center py-6">
        {status === "loading" && <Loader2 className="w-10 h-10 animate-spin text-teal mx-auto" />}
        {status === "ok" && (
          <div><CheckCircle2 className="w-14 h-14 text-status-green mx-auto mb-3" /><p className="text-navy font-semibold">Email berhasil diverifikasi!</p></div>
        )}
        {status === "error" && (
          <div><XCircle className="w-14 h-14 text-status-red mx-auto mb-3" /><p className="text-navy font-semibold">Tautan tidak valid atau sudah kedaluwarsa.</p></div>
        )}
      </div>
    </AuthShell>
  );
}
